import { AntragDtoModel } from './AntragDtoModel';

export class AntragListViewModel extends AntragDtoModel {
  public canDecrypt: boolean | undefined;
  public isDraft: boolean | undefined;
  public title: string | undefined;
}
